import questions from '@/scripts/questions';

export default {
  currentGame: {
    gameStarted: false,
    questionsIndex: null,
    groupIndex: -1,
    partialScore: 0,
    gameEnded: false,
    answerChecked: false,
    answerCorrect: false,
    questionsIdList: [],
    showProgress: false,
    showNext: false,
  },
  questions,
};
